import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  juzgado_selected: {}, //seleccionara el objeto de la lista de magistrados
  juzgados: []
};
export const mutations = {
  SELECT_JUZGADO({ context }, juzgado) {
    return (state.juzgado_selected = Object.assign({}, juzgado));
  },
  FILL_JUZGADOS({ context }, list_juzgados) {
    let juzgados = [];
    Object.entries(list_juzgados).forEach(([key, val]) => juzgados.push(val));
    return (state.juzgados = juzgados);
  }
};
export const actions = {
  GET_ALL_JUZGADOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_JUZGADOS", response.data.data.juzgados);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_JUZGADO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_JUZGADO({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_JUZGADO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllJuzgados: state => {
    return state.juzgados;
  },
  getJuzgadosByMateria: (state, getters) => {
    const materia = getters.getAllJuzgados.filter(juzgado => {
      if (juzgado.materia_data.nombre == 'PENAL ORAL') {
        return true;
      }
    });
    return materia;
  }
};
